import { productAddToCart as productAction } from './actionProduct.data';
/** @namespace Bodymod/Matomo/EventData/CartItems/Data/parseCartData */
export function parseCartData(items) {
    const products = items.map((product) => productAction(product));

    return { products };
}
